import { Utils } from "@grandvisionhq/auth";
const toUpdatedOptIns = ({
  changedOptIns,
  optInsFromServer,
  availableOptIns,
  getLabel
}) => {
  return Object.entries(changedOptIns).reduce((acc, [key, optIn]) => {
    const availableOptIn = Utils.ungroupOptIns(availableOptIns).find((a) => a.value === key);
    if (!availableOptIn) {
      return acc;
    }
    const serverOptIn = optInsFromServer.find((a) => a.id === key);
    if (serverOptIn && serverOptIn.value === optIn.checked) {
      return acc;
    }
    const literalText = getLabel(availableOptIn.titleKey);
    return [
      ...acc,
      {
        id: key,
        literalText,
        value: optIn.checked
      }
    ];
  }, []);
};
export {
  toUpdatedOptIns
};
//# sourceMappingURL=opt-in-input.js.map
